import React from "react";
import { ILiensCommercialisationParType } from "../../../models/interfaces/ISociete";

import RowDetailParenthese from "../components/detail/RowDetailParenthese";
import { stringToTypeLienCommercialisation } from "../../../models/interfaces/ITypeLienCommercialisation";
//Styles:

interface IProps {
  LiensCommercialisationParType: ILiensCommercialisationParType;
}



const MarqueBloc4: React.FC<IProps> = ({
  LiensCommercialisationParType
}) => {
  return (
    <div className="card mb-2 pae-detail-pub-card ">
            <div className="col-sm-12 card-body pae-card-grey" style={{maxHeight: "50px" , textAlign: 'left'}}>
            <div className="row">
                  <div className="col-12 pae-detail-label">
                      <b>{stringToTypeLienCommercialisation(LiensCommercialisationParType?.TypeLienCommercialisation)}</b> 
                  </div>
              </div>
            </div>
              <div className="col-sm-12 card-body" style={{ padding: '15px' }}>
                
              {LiensCommercialisationParType?.LiensCommercialisation?.map((lien, index) => (
                  <RowDetailParenthese 
                    titreCol="12"
                    key={index} 
                    titre={lien.RaisonSocialeSocieteLiencommercialisation} 
                    donnee={lien.ZoneGeographique} 
                  />
                ))}
              </div>
            </div>
  );
};

export default MarqueBloc4;
